import { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { StandardLayout, Flex } from '@sequencehq/core-components'
import Spinner from 'components/Loading/Spinner'
import { ProductMeta } from 'modules/Products/Product/ProductMeta'
import { ProductPriceVariants } from 'modules/Products/Product/components/ProductPriceVariants'
import { useProduct } from 'modules/Products/hooks/useProduct'
import { ProductListPrices } from 'modules/Products/Product/components/ProductListPrices'
import NotFound from 'components/ErrorPages/NotFound'
import { ProductInspector } from 'Products/Product/ProductInspector'
import { useLogLoadTime } from 'lib/postHog/useLogLoadTime'
import { HeaderBreadcrumbs, HeaderButtons } from './components'

export const Product: FC = () => {
  const { product, isLoading } = useProduct()

  useLogLoadTime({
    ready: !isLoading,
    eventName: 'product_page_loaded'
  })

  if (isLoading) return <Spinner />
  if (!product) return <NotFound />

  return (
    <StandardLayout
      header={
        <StandardLayout.Header
          title={<HeaderBreadcrumbs />}
          actions={
            <StandardLayout.Actions>
              <HeaderButtons />
            </StandardLayout.Actions>
          }
        />
      }
      content={
        <StandardLayout.Content scrollable>
          <Flex gap="32px" flexDir="column">
            <ProductMeta />
            <ProductListPrices />
            <ProductPriceVariants />
          </Flex>
          <Outlet />
        </StandardLayout.Content>
      }
      inspector={<ProductInspector productId={product.id} />}
    />
  )
}
